export const mathRole = {
    name: 'math',
    body: {
        type: String,
        required: true,
    },
    run(data) {
        return [{ type: 'inlineMath', value: data.body }];
    },
};
